module.exports = __webpack_public_path__ + "img/public/siteImages/insuranceImage.jpg?5f4af84a";